import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { SnackComponent } from './snack.component';

const SNACK_BAR_SUCCESS_DURATION = 3000; //In milliseconds
const SNACK_BAR_ERROR_DURATION = 9000;
const SNACK_BAR_PANEL_CLASS = 'tm-snackbar';

export type SnackBarLevel = 'success' | 'error';

@Injectable({
  providedIn: 'root'
})
export class SnackBarService {

  constructor(
    private _snackBar: MatSnackBar,
    private _translateService: TranslateService,
  ) { }
  
  success(message: string) {
    this._openSnackBar(message, 'success');
  }

  error(message: string) {
    this._openSnackBar(message, 'error');
  }

  private _openSnackBar(msg: string, level: SnackBarLevel) {
    if (!msg) { return; }

    if (typeof msg !== 'string') {
      msg = JSON.stringify(msg);
    }

    //Ensure the message is translated if necessary
    const message = this._translateService.instant(msg);
    
    this._snackBar.openFromComponent(SnackComponent, {
      data: { message, level },
      duration: level === 'error' ? SNACK_BAR_ERROR_DURATION : SNACK_BAR_SUCCESS_DURATION,
      panelClass: [SNACK_BAR_PANEL_CLASS, `${level}-snackbar`]
    })
  }
}